import React from 'react';
import PropTypes from 'prop-types';
import GreetingHeader from '../../shared/GreetingHeader';

const PharmacyDashboard = ({ user, navigateTo }) => (
  <div className="p-6">
    <GreetingHeader name={user?.name} />
    
    <div className="labdashboard grid grid-cols-4 sm:grid-cols-2  gap-6"> 
     <div className="quick-actions pending items-center col-span-2 col-start-1 bg-white border rounded-xl shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Quick Actions</h3>
        <div className="flex gap-[10px]">

          <button
            type="button"
            onClick={() => navigateTo('Prescription_queue')}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded-lg shadow"
          >
            📋 View Prescription Queue
          </button>

          <button
            type="button"
            onClick={() => navigateTo('add_med')}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded-lg shadow"
          >
            +  Add Medicine
          </button>
        </div>
      </div>
    </div>
  </div>
);

PharmacyDashboard.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  navigateTo: PropTypes.func.isRequired,
};

export default PharmacyDashboard;
